// extracted by mini-css-extract-plugin
export default {"csSearchForm":"SearchForm_csSearchForm__Lao9i","reverse":"SearchForm_reverse__7L96g"};